if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.swiperInstance = null;
      }

      hide() {
        super.hide();
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      show(opener) {
        super.show(opener);
        this.initializeSwiper(opener);
      }

      initializeSwiper(opener) {
        const swiperContainer = this.querySelector('.js-product-swiper');
        if (swiperContainer) {
          const mediaId = opener.dataset.mediaId;
          const slides = swiperContainer.querySelectorAll('.swiper-slide[data-media-id]');
          let initialSlideIndex = 0;

          slides.forEach((slide, index) => {
            if (slide.dataset.mediaId === mediaId) {
              initialSlideIndex = index;
            }
          });

          this.swiperInstance = new Swiper(swiperContainer, {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
              nextEl: this.querySelector('.swiper-button-next'),
              prevEl: this.querySelector('.swiper-button-prev'),
            },
            pagination: {
              el: this.querySelector('.swiper-pagination'),
              clickable: true,
            },
            initialSlide: 0,
          });
          requestAnimationFrame(() => {
            this.swiperInstance.slideToLoop(initialSlideIndex, 0, false);
          }); 
        }
      }
    }
  );
}